/* istanbul ignore file */
import { onlineCalculatorsApiSaga } from '@esprit/online-calculators';
import { all, call } from 'redux-saga/effects';
import { applicationSaga } from './application';
import { appointmentsApiSaga } from './appointments-api/appointments-api-saga';
import { chatApiSaga } from './chat-api/chat-api-saga';
import { contactFormSaga } from './contact-form/contact-form-saga';
import { customerBaseApiSaga } from './customer-base-api';
import { customerMasterDataApiSaga } from './customer-master-data-api';
import { employeeMasterDataSaga } from './employee-master-data-api';
import { finnovaApiSaga } from './finnova-api';
import { iamApiSaga } from './iam-api';
import { loggingApiSaga } from './logging-api/logging-api-saga';
import { notificationsApiSaga } from './notifications-api/notifications-api-saga';
import { portalAccountApiSaga } from './portal-account-api';
import { processEngineApiSaga } from './process-engine-api';
import { secureDocumentStoreApiSaga } from './secure-document-store-api/secure-document-store-api-saga';
import { secureInboxApiSaga } from './secure-inbox-api/secure-inbox-api-saga';
import { settingsApiSaga } from './settings-api/settings-api-saga';
import { userInfoApiSaga } from './user-info-api';

export default function* rootSaga(): IterableIterator<any> {
    yield all([
        call(applicationSaga),
        call(portalAccountApiSaga),
        call(customerMasterDataApiSaga),
        call(employeeMasterDataSaga),
        call(userInfoApiSaga),
        call(settingsApiSaga),
        call(appointmentsApiSaga),
        call(chatApiSaga),
        call(secureDocumentStoreApiSaga),
        call(secureInboxApiSaga),
        call(notificationsApiSaga),
        call(contactFormSaga),
        call(loggingApiSaga),
        call(onlineCalculatorsApiSaga),
        call(customerBaseApiSaga),
        call(processEngineApiSaga),
        call(finnovaApiSaga),
        call(iamApiSaga),
    ]);
}
